// 404 page for unknown routes inside the App Shell
// (T-036, plan §5.6, spec §6.1).
//
// Per spec: the URL stays as-is so the user can copy it for support.
// The page renders the regular sidebar + header + a centered Compass
// + headline + sub-line + "Back to Home" CTA.

import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Compass } from 'lucide-react';

export function NotFound() {
  const navigate = useNavigate();
  return (
    <div
      className="p-12 flex flex-col items-center justify-center h-[calc(100vh-80px)] text-center"
      data-testid="not-found"
    >
      <Compass size={72} className="text-slate-300 mb-6" aria-hidden="true" />
      <h1 className="text-2xl font-bold text-slate-800">
        We couldn't find that page
      </h1>
      <p className="text-sm text-slate-500 mt-2 max-w-md">
        The link may be out of date, or the page may have been moved.
      </p>
      <button
        type="button"
        onClick={() => navigate('/')}
        className="mt-6 inline-flex items-center gap-2 bg-[#6344C6] hover:bg-[#5235a8] text-white px-5 py-2.5 rounded-xl font-bold shadow-md"
        data-testid="not-found-back-home"
      >
        <ArrowLeft size={16} aria-hidden="true" /> Back to Home
      </button>
    </div>
  );
}
